import { DeviceUtil } from "./control.util";
import { CanvasListDraw } from "./layout.canvas.list";
import { Constant } from "./layout.constant";

class CanvasDraw {


    static drawLine(canvas, element) {
        const ctx = canvas.getContext("2d");
        const dcunit = this.#convertPoint(element);
        ctx.save(); //保存上述设置的绘制状态
        ctx.lineJoin = "round";
        ctx.strokeStyle = element.color;
        ctx.lineWidth = element.weight;
        if (element.type == '0') {//线条
            ctx.beginPath();
            ctx.moveTo(dcunit.ax1, dcunit.ay1)
            ctx.lineTo(dcunit.ax2, dcunit.ay2)
            ctx.stroke()
        } else if (element.type == '1') {//椭圆
            ctx.beginPath();
            const rx = (dcunit.ax2 - dcunit.ax1) / 2
            const ry = (dcunit.ay2 - dcunit.ay1) / 2
            const x = dcunit.ax1 + rx
            const y = dcunit.ay1 + ry
            ctx.ellipse(x, y, Math.abs(rx), Math.abs(ry), 0, 0, 2 * Math.PI);
            ctx.stroke();
        } else if (element.type == '2') {//矩形
            ctx.strokeRect(dcunit.ax1, dcunit.ay1, dcunit.ax2 - dcunit.ax1, dcunit.ay2 - dcunit.ay1);
        }
        ctx.restore();
    }

    static drawText(canvas, element) {
        const dcunit = this.#convertPoint(element);
        const rect = { ax: dcunit.ax1, ay: dcunit.ay1, width: dcunit.ax2 - dcunit.ax1, height: dcunit.ay2 - dcunit.ay1 }
        this.#drawRectText(canvas, element, element.text, rect);
        this.#drawElementBorder(canvas, rect)
    }

    static drawImage(canvas, element) {
        const dcunit = this.#convertPoint(element);
        const rect = { ax: dcunit.ax1, ay: dcunit.ay1, width: dcunit.ax2 - dcunit.ax1, height: dcunit.ay2 - dcunit.ay1 }
        this.#drawImageElement(canvas, element.img, rect)
        this.#drawElementBorder(canvas, rect)
    }

    static drawBarcode(canvas, element) {
        const dcunit = this.#convertPoint(element);
        const rect = { ax: dcunit.ax1, ay: dcunit.ay1, width: dcunit.ax2 - dcunit.ax1, height: dcunit.ay2 - dcunit.ay1 }
        this.#drawImageElement(canvas, element.img, rect)
        this.#drawElementBorder(canvas, rect)
    }

    static drawQrcode(canvas, element) {
        const dcunit = this.#convertPoint(element);
        const rect = { ax: dcunit.ax1, ay: dcunit.ay1, width: dcunit.ax2 - dcunit.ax1, height: dcunit.ay2 - dcunit.ay1 }
        this.#drawImageElement(canvas, element.img, rect)
        this.#drawElementBorder(canvas, rect)
    }

    static drawList(canvas, element) {
        let fill = false
        if (element.rows.length == 0) {
            fill = true
            element.rows.push({})
        }
        //const rowCount = this.#drawListBorder(canvas, element);
        const ctx = canvas.getContext("2d");
        ctx.save(); //保存上述设置的绘制状态
        ctx.lineWidth = element.weight;
        const rowCount = CanvasListDraw.drawListBorder(
            element,
            element.rows,
            (value) => {
                return this.#convertPointUnit(value)
            },
            (border, x1, y1, x2, y2, weight, color) => {
                this.#createBorderStyle(element, border, ctx);
                ctx.beginPath();
                ctx.moveTo(x1, y1)
                ctx.lineTo(x2, y2)
                ctx.stroke()
            },
        );
        ctx.restore();


        this.#drawListContent(canvas, element, rowCount)
        if (fill) {
            element.rows = []
        }
    }

    static drawDragLinePoint(canvas, element) {
        const ctx = canvas.getContext("2d");
        const dcunit = this.#convertPoint(element);
        const dclen = this.#convertPointUnit(Constant.POINT_WIDTH)
        ctx.save(); //保存上述设置的绘制状态
        ctx.fillStyle = Constant.POINT_COLOR;
        ctx.fillRect(dcunit.ax1 - dclen, dcunit.ay1 - dclen, dclen * 2, dclen * 2);
        ctx.fillRect(dcunit.ax2 - dclen, dcunit.ay2 - dclen, dclen * 2, dclen * 2);
        ctx.restore();
    }

    static drawDragRectPoint(canvas, element) {
        const ctx = canvas.getContext("2d");
        const dcunit = this.#convertPoint(element);
        const dclen = this.#convertPointUnit(Constant.POINT_WIDTH)
        ctx.save(); //保存上述设置的绘制状态
        ctx.fillStyle = Constant.POINT_COLOR;
        ctx.fillRect(dcunit.ax1 - dclen, dcunit.ay1 - dclen, dclen * 2, dclen * 2);
        ctx.fillRect(dcunit.ax2 - dclen, dcunit.ay1 - dclen, dclen * 2, dclen * 2);
        ctx.fillRect(dcunit.ax2 - dclen, dcunit.ay2 - dclen, dclen * 2, dclen * 2);
        ctx.fillRect(dcunit.ax1 - dclen, dcunit.ay2 - dclen, dclen * 2, dclen * 2);
        ctx.restore();
    }

    static drawRectPoint(canvas, point1, point2) {
        const ctx = canvas.getContext("2d");
        ctx.save(); //保存上述设置的绘制状态
        ctx.strokeStyle = "#696969";
        ctx.setLineDash([4, 4])
        ctx.strokeRect(this.#convertPointUnit(point1.offsetX), this.#convertPointUnit(point1.offsetY), this.#convertPointUnit(point2.offsetX - point1.offsetX), this.#convertPointUnit(point2.offsetY - point1.offsetY));
        ctx.restore();
    }

    static drawBackgroundImage(canvas, img, width, height, direction) {
        const ctx = canvas.getContext("2d");
        ctx.save(); //保存上述设置的绘制状态
        if (direction == Constant.DIRECTION_PORTRAIT) {
            ctx.drawImage(img, 0, 0, width, height);
        } else {
            ctx.drawImage(img, 0, 0, height, width);
        }
        ctx.restore();
    }


    //
    static #drawListBorder(canvas, element) {
        const ctx = canvas.getContext("2d");
        const dcunit = this.#convertPoint(element);

        const dcrowheight = this.#convertPointUnit(element.rowHeight)
        const dctitleheight = this.#convertPointUnit(element.titleHeight)
        const dcfooterHeight = this.#convertPointUnit(element.footerHeight)

        const dclistwidth = dcunit.ax2 - dcunit.ax1
        const dclistheight = dcunit.ay2 - dcunit.ay1

        ctx.save(); //保存上述设置的绘制状态
        ctx.lineWidth = element.weight;


        //计算行数等
        let capacitHeight = (element.ay2 - element.ay1)
        if (element.title) {
            capacitHeight -= element.titleHeight
        }
        if (element.footer) {
            capacitHeight -= element.footerHeight
        }
        const capacityrows = parseInt(capacitHeight / element.rowHeight)

        let rows = 0
        if (element.rowfill) {
            rows = capacityrows
        } else {
            rows = Math.min(capacityrows, element.rows.length)
        }


        let offsetYtemp = 0
        //表头
        if (element.title && dclistheight - offsetYtemp >= dctitleheight) {
            //顶线
            this.#createBorderStyle(element, element.titleTop, ctx);
            ctx.beginPath();
            ctx.moveTo(dcunit.ax1, dcunit.ay1)
            ctx.lineTo(dcunit.ax2, dcunit.ay1)
            ctx.stroke()

            //左侧
            this.#createBorderStyle(element, element.titleLeft, ctx);
            ctx.beginPath();
            ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp)
            ctx.lineTo(dcunit.ax1, dcunit.ay1 + offsetYtemp + dctitleheight)
            ctx.stroke()

            //右侧
            this.#createBorderStyle(element, element.titleRight, ctx);
            ctx.beginPath();
            ctx.moveTo(dcunit.ax2, dcunit.ay1 + offsetYtemp)
            ctx.lineTo(dcunit.ax2, dcunit.ay1 + offsetYtemp + dctitleheight)
            ctx.stroke()

            let offsetXtemp = 0
            for (let index = 0; index < element.cols.length - 1; index++) {
                const col = element.cols[index];
                const dcwidth = this.#convertPointUnit(col.width)
                if (dcunit.ax1 + offsetXtemp + dcwidth < dcunit.ax2) {
                    this.#createBorderStyle(element, element.titleInside, ctx);
                    ctx.beginPath();
                    ctx.moveTo(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1)
                    ctx.lineTo(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + dctitleheight)
                    ctx.stroke()
                    offsetXtemp += dcwidth
                } else {
                    break;
                }
            }


            if (element.titleBottom && !element.rowTop) {
                this.#createBorderStyle(element, element.titleBottom, ctx);
                ctx.beginPath();
                ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp + dctitleheight)
                ctx.lineTo(dcunit.ax2, dcunit.ay1 + offsetYtemp + dctitleheight)
                ctx.stroke()
            }
            offsetYtemp += dctitleheight
        }

        //表体
        for (let index = 0; index < rows; index++) {
            if (index == 0) {
                //顶部线
                this.#createBorderStyle(element, element.rowTop, ctx);
                ctx.beginPath();
                ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp)
                ctx.lineTo(dcunit.ax2, dcunit.ay1 + offsetYtemp)
                ctx.stroke()
            }

            if (index == rows - 1) {
                //底部
                this.#createBorderStyle(element, element.rowBottom, ctx);
                ctx.beginPath();
                ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp + dcrowheight)
                ctx.lineTo(dcunit.ax2, dcunit.ay1 + offsetYtemp + dcrowheight)
                ctx.stroke()
            } else {
                //中间
                this.#createBorderStyle(element, element.rowInsideH, ctx);
                ctx.beginPath();
                ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp + dcrowheight)
                ctx.lineTo(dcunit.ax2, dcunit.ay1 + offsetYtemp + dcrowheight)
                ctx.stroke()
            }

            //左侧
            this.#createBorderStyle(element, element.rowLeft, ctx);
            ctx.beginPath();
            ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp)
            ctx.lineTo(dcunit.ax1, dcunit.ay1 + offsetYtemp + dcrowheight)
            ctx.stroke()

            //右侧
            this.#createBorderStyle(element, element.rowRight, ctx);
            ctx.beginPath();
            ctx.moveTo(dcunit.ax2, dcunit.ay1 + offsetYtemp)
            ctx.lineTo(dcunit.ax2, dcunit.ay1 + offsetYtemp + dcrowheight)
            ctx.stroke()


            //中间垂直线
            let offsetXtemp = 0
            for (let index = 0; index < element.cols.length - 1; index++) {
                const col = element.cols[index];
                const dcwidth = this.#convertPointUnit(col.width)
                if (dcunit.ax1 + offsetXtemp + dcwidth <= dcunit.ax2) {
                    this.#createBorderStyle(element, element.rowInsideV, ctx);
                    ctx.beginPath();
                    ctx.moveTo(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + offsetYtemp)
                    ctx.lineTo(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + offsetYtemp + dcrowheight)
                    ctx.stroke()
                }
                offsetXtemp += dcwidth
            }
            offsetYtemp += dcrowheight
        }

        //表尾
        if (element.footer && dclistheight - offsetYtemp >= dcfooterHeight) {
            //顶部
            if (element.footerTop && !element.rowBottom) {
                this.#createBorderStyle(element, element.footerTop, ctx);
                ctx.beginPath();
                ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp)
                ctx.lineTo(dcunit.ax2, dcunit.ay1 + offsetYtemp)
                ctx.stroke()
            }

            //左侧
            this.#createBorderStyle(element, element.footerLeft, ctx);
            ctx.beginPath();
            ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp)
            ctx.lineTo(dcunit.ax1, dcunit.ay1 + offsetYtemp + dcfooterHeight)
            ctx.stroke()

            //右侧
            this.#createBorderStyle(element, element.footerRight, ctx);
            ctx.beginPath();
            ctx.moveTo(dcunit.ax2, dcunit.ay1 + offsetYtemp)
            ctx.lineTo(dcunit.ax2, dcunit.ay1 + offsetYtemp + dcfooterHeight)
            ctx.stroke()

            //底部
            this.#createBorderStyle(element, element.footerBottom, ctx);
            ctx.beginPath();
            ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp + dcfooterHeight)
            ctx.lineTo(dcunit.ax2, dcunit.ay1 + offsetYtemp + dcfooterHeight)
            ctx.stroke()

            //表尾的内部线
            let offsetXtemp = 0
            let colspantemp = 0
            let colwidthtemp = 0
            this.#createBorderStyle(element, element.footerInside, ctx);
            for (let index = 0; index < element.cols.length - 1; index++) {
                const col = element.cols[index];
                const dcwidth = this.#convertPointUnit(col.width)
                const colspan = col.footerColspan
                if (colspantemp - 1 > 0) {
                    colwidthtemp += dcwidth
                    colspantemp--;
                } else if (colspantemp == 1) {
                    colwidthtemp += dcwidth
                    if (dcunit.ax1 + offsetXtemp + colwidthtemp < dcunit.ax2) {
                        ctx.beginPath();
                        ctx.moveTo(dcunit.ax1 + offsetXtemp + colwidthtemp, dcunit.ay1 + offsetYtemp)
                        ctx.lineTo(dcunit.ax1 + offsetXtemp + colwidthtemp, dcunit.ay1 + offsetYtemp + dcfooterHeight)
                        ctx.stroke()
                    }
                    offsetXtemp += colwidthtemp
                    colspantemp = 0
                    colwidthtemp = 0
                } else {
                    if (colspan > 1) {
                        colwidthtemp = dcwidth
                        colspantemp = colspan - 1;
                    } else {
                        let colofx = 0
                        if (dcunit.ax1 + offsetXtemp + dcwidth < dcunit.ax2) {
                            ctx.beginPath();
                            ctx.moveTo(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + offsetYtemp)
                            ctx.lineTo(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + offsetYtemp + dcfooterHeight)
                            ctx.stroke()
                        }
                        offsetXtemp += dcwidth
                    }
                }
            }
            offsetYtemp += dcfooterHeight
        }

        //未占用空间
        if (offsetYtemp < dclistheight) {
            ctx.beginPath();
            ctx.strokeStyle = "#696969";
            ctx.setLineDash([4, 4])
            ctx.moveTo(dcunit.ax1, dcunit.ay1 + offsetYtemp)
            ctx.lineTo(dcunit.ax1, dcunit.ay1 + dclistheight)
            ctx.stroke()
            ctx.moveTo(dcunit.ax2, dcunit.ay1 + offsetYtemp)
            ctx.lineTo(dcunit.ax2, dcunit.ay1 + dclistheight)
            ctx.stroke()
            ctx.moveTo(dcunit.ax1, dcunit.ay1 + dclistheight)
            ctx.lineTo(dcunit.ax2, dcunit.ay1 + dclistheight)
            ctx.stroke()
        }
        ctx.restore();
        return rows
    }

    static #drawListContent(canvas, element, rowCount) {
        const dcunit = this.#convertPoint(element);
        const dctitleheight = this.#convertPointUnit(element.titleHeight)
        const dcrowheight = this.#convertPointUnit(element.rowHeight)
        const dcfooterHeight = this.#convertPointUnit(element.footerHeight)
        const dclistwidth = dcunit.ax2 - dcunit.ax1
        const dclistheight = dcunit.ay2 - dcunit.ay1

        //绘制表头
        let offsetYtemp = 0
        if (element.title && dctitleheight + offsetYtemp <= dclistheight) {
            let offsetXtemp = 0
            for (let index = 0; index < element.cols.length; index++) {
                if (offsetXtemp >= dclistwidth) {
                    break;
                }
                const col = element.cols[index];
                let dcwidth = this.#convertPointUnit(col.width)
                if (index == element.cols.length - 1) {
                    dcwidth = dclistwidth - offsetXtemp
                }
                const rect = {
                    ax1: dcunit.ax1 + offsetXtemp + col.padding,
                    ay1: dcunit.ay1 + offsetYtemp + col.padding,
                    ax2: Math.min(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ax2) - col.padding,
                    ay2: dcunit.ay1 + offsetYtemp + dctitleheight - col.padding
                }
                rect.ax = rect.ax1
                rect.ay = rect.ay1
                rect.width = rect.ax2 - rect.ax1
                rect.height = rect.ay2 - rect.ay1
                this.#drawRectText(canvas, col, col.title, rect)
                offsetXtemp += dcwidth
            }
            offsetYtemp += dctitleheight
        }

        //绘制表体
        for (let index = 0; index < rowCount; index++) {
            if (index == 0) {
                let offsetXtemp = 0
                for (let index = 0; index < element.cols.length; index++) {
                    if (offsetXtemp >= dclistwidth) {
                        break;
                    }
                    const col = element.cols[index];
                    let dcwidth = this.#convertPointUnit(col.width)
                    if (index == element.cols.length - 1) {
                        dcwidth = dclistwidth - offsetXtemp
                    }
                    const rect = {
                        ax1: dcunit.ax1 + offsetXtemp + col.padding,
                        ay1: dcunit.ay1 + offsetYtemp + col.padding,
                        ax2: Math.min(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ax2) - col.padding,
                        ay2: dcunit.ay1 + offsetYtemp + dcrowheight - col.padding
                    }
                    rect.ax = rect.ax1
                    rect.ay = rect.ay1
                    rect.width = rect.ax2 - rect.ax1
                    rect.height = rect.ay2 - rect.ay1
                    this.#drawRectText(canvas, col, `{${col.field}}`, rect)
                    offsetXtemp += dcwidth
                }
            }
            offsetYtemp += dcrowheight
        }

        //绘制表尾
        if (element.footer && dcfooterHeight + offsetYtemp <= dclistheight) {
            let offsetXtemp = 0 //单元格起点偏移
            let colspantemp = 0 //单元格跨列计算剩余
            let colwidthtemp = 0 //单元格跨列计算当前宽度
            let colelement = undefined
            for (let index = 0; index < element.cols.length; index++) {
                if (offsetXtemp >= dclistwidth) {
                    break;
                }
                const col = element.cols[index];
                let dcwidth = this.#convertPointUnit(col.width)
                if (index == element.cols.length - 1) {
                    dcwidth = dclistwidth - (offsetXtemp + colwidthtemp)
                }
                const colspan = Math.max(parseInt(col.footerColspan), 1)


                if (colspantemp - 1 > 0) {
                    colwidthtemp += dcwidth
                    colspantemp--;
                } else if (colspantemp == 1) {
                    colwidthtemp += dcwidth
                    const rect = {
                        ax1: dcunit.ax1 + offsetXtemp + col.padding,
                        ay1: dcunit.ay1 + offsetYtemp + col.padding,
                        ax2: Math.min(dcunit.ax1 + offsetXtemp + colwidthtemp, dcunit.ax2) - col.padding,
                        ay2: dcunit.ay1 + offsetYtemp + dctitleheight - col.padding
                    }
                    rect.ax = rect.ax1
                    rect.ay = rect.ay1
                    rect.width = rect.ax2 - rect.ax1
                    rect.height = rect.ay2 - rect.ay1
                    this.#drawRectText(canvas, colelement, colelement.footerText, rect)
                    offsetXtemp += colwidthtemp

                    colspantemp = 0
                    colwidthtemp = 0
                    colelement = undefined
                } else {
                    if (colspan > 1) {
                        colwidthtemp = dcwidth
                        colspantemp = colspan - 1;
                        colelement = col
                    } else {
                        const rect = {
                            ax1: dcunit.ax1 + offsetXtemp + col.padding,
                            ay1: dcunit.ay1 + offsetYtemp + col.padding,
                            ax2: Math.min(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ax2) - col.padding,
                            ay2: dcunit.ay1 + offsetYtemp + dctitleheight - col.padding
                        }
                        rect.ax = rect.ax1
                        rect.ay = rect.ay1
                        rect.width = rect.ax2 - rect.ax1
                        rect.height = rect.ay2 - rect.ay1
                        this.#drawRectText(canvas, col, col.footerText, rect)
                        offsetXtemp += dcwidth
                    }
                }
            }
        }
    }


    static #drawRectText(canvas, style, text, rect) {
        const ctx = canvas.getContext("2d");
        ctx.save(); //保存上述设置的绘制状态
        ctx.font = this.#createFontStyle(style);
        ctx.fillStyle = style.color;

        ctx.textAlign = style.align
        text += "";
        const textMetrics = ctx.measureText(text);
        if (textMetrics.width < rect.width) {
            let voffset = 0
            let hoffset = 0

            if (style.align == 'left') {

            } else if (style.align == 'center') {
                hoffset = (rect.width) / 2
            } else if (style.align == 'right') {
                hoffset = rect.width
            }

            if (style.vertical == 'middle') {
                ctx.textBaseline = "middle"
                voffset = rect.height / 2
            } else if (style.vertical == 'top') {
                ctx.textBaseline = "top"
            } else if (style.vertical == 'bottom') {
                ctx.textBaseline = "bottom"
                voffset = rect.height
            }
            ctx.fillText(text, rect.ax + hoffset, rect.ay + voffset);
        } else {
            let voffset = 0
            let hoffset = 0

            if (style.align == 'left') {
            } else if (style.align == 'center') {
                hoffset = (rect.width) / 2
            } else if (style.align == 'right') {
                hoffset = rect.width
            }
            const lineHeight = style.size * 1.2
            const showText = []
            const rowcount = parseInt(rect.height / lineHeight)

            for (let i = 0; i < text.length; i++) {
                if (i == 0) {
                    showText.push("")
                }
                if (ctx.measureText(showText.at(-1) + text[i]).width > rect.width) {
                    if (showText.length >= rowcount) {
                        break;
                    }
                    showText.push("")
                    showText[showText.length - 1] = showText.at(-1) + text[i]
                } else {
                    showText[showText.length - 1] = showText.at(-1) + text[i]
                }
            }

            if (style.vertical == 'middle') {
                ctx.textBaseline = "middle"
                voffset = (rect.height / 2) - (lineHeight * showText.length / 2) + lineHeight / 2
                for (let index = 0; index < showText.length; index++) {
                    ctx.fillText(showText[index], rect.ax + hoffset, rect.ay + voffset);
                    voffset += lineHeight
                }
            } else if (style.vertical == 'top') {
                ctx.textBaseline = "top"
                for (let index = 0; index < showText.length; index++) {
                    ctx.fillText(showText[index], rect.ax + hoffset, rect.ay + voffset);
                    voffset += lineHeight
                }
            } else if (style.vertical == 'bottom') {
                ctx.textBaseline = "bottom"
                voffset = (rect.height - lineHeight * showText.length) + lineHeight
                for (let index = 0; index < showText.length; index++) {
                    ctx.fillText(showText[index], rect.ax + hoffset, rect.ay + voffset);
                    voffset += lineHeight
                }
                voffset = rect.height
            }
        }
        ctx.restore();
    }

    static #drawImageElement(canvas, img, rect) {
        const ctx = canvas.getContext("2d");
        ctx.save(); //保存上述设置的绘制状态
        ctx.drawImage(img, rect.ax, rect.ay, rect.width, rect.height);
        ctx.restore();
    }

    static #drawElementBorder(canvas, rect) {
        const ctx = canvas.getContext("2d");
        ctx.save(); //保存上述设置的绘制状态
        ctx.strokeStyle = "#696969";
        ctx.setLineDash([4, 4])
        ctx.strokeRect(rect.ax, rect.ay, rect.width, rect.height);
        ctx.restore();
    }

    static #createBorderStyle(element, border, ctx) {
        if (border) {
            ctx.strokeStyle = element.borderColor;
            ctx.setLineDash([])
        } else {
            ctx.strokeStyle = "#696969";
            ctx.setLineDash([4, 4])
        }
    }

    static #createFontStyle(data) {
        const fontArr = []
        if (data.bold) {
            fontArr.push("bold")
        }
        if (data.italic) {
            fontArr.push("italic")
        }
        fontArr.push(`${data.size}px`)
        fontArr.push(`${data.font}`)
        return fontArr.join(" ")
    }

    static #convertPoint(element) {
        return {
            ax1: DeviceUtil.dcConversionPx(element.ax1),
            ay1: DeviceUtil.dcConversionPx(element.ay1),
            ax2: DeviceUtil.dcConversionPx(element.ax2),
            ay2: DeviceUtil.dcConversionPx(element.ay2),
        }
    }

    static #convertPointUnit(value) {
        return DeviceUtil.dcConversionPx(value)
    }
}


export {
    CanvasDraw
}